import React, { Component } from 'react';
import autoBind from 'react-autobind';
import OperatorNotificationList from 'src/components/nav/components/operator-notification-list';

export const NOTIFICATION_MENU_TYPES = Object.freeze({
    TASK: 'TASK',
    NOTIFICATION: 'NOTIFICATION',
    NEWSLETTER: 'NEWSLETTER',
});

class OperatorNotificationsPopupModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    render() {
        const { t, notifications } = this.props;
        return (
            <>
                <div className="col-md-12 bf-operator-notification-content">
                    <OperatorNotificationList
                        t={t}
                        notifications={notifications}
                        title={t('operator_notifications.modal.recent_notifications')}
                    />
                </div>
            </>
        );
    }
}

export default OperatorNotificationsPopupModal;
